import Core from "@/modules/core/service/Core";

const state = {
    formats : [],
    reports : []
}

const mutations = {
    updateReportEnums (state, payload) {
        state.reports  = payload.reports;
        state.formats  = payload.formats;
    },
}

const actions = {
    initReportEnums ( { commit }) {
        return Core.method.get("/api/report/enums").then(data => {
            commit ('updateReportEnums', data);
        })
    },
}

const getters = {
    reportFormats: state => {
        return state.formats;
    },

    reportDefinitions: state => {
        return state.reports;
    },
}

const repModule = {
    state,
    mutations,
    actions,
    getters
}

export default repModule